import React from "react";
import Box from "./Box";
import { Helpers } from "../helpers/Helpers";
import CustomTextInput from "./CustomTextInput";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../redux/store";
import { storeAreYouSureModalCallback } from "../redux/reducers/authSlice";

interface Props {
    selectedCount: number
    pageName: string
    searchTerm: string
    setSearchTerm: (_value: string) => void
    onSearchSubmit: (e: any) => void
    /**
     * Kayıtları otomatik dolan ya da entegrasyonla gelen ekranlarda (Faturalanacaklar,
     * Banka Hareketleri) yalnızca arama kutusu gösterilir; Güncelle ve Sil düğmeleri
     * yetki olsa bile çıkmaz. Bu ekranlarda kayıt elle düzenlenmez ya da silinmez.
     */
    searchOnly?: boolean
    /**
     * Arama kutusu gösterilmez (kolon başlığı altında filtresi olan ekranlar; ör. Yurtiçi
     * Siparişler). Güncelle ve Sil düğmeleri yine çıkar; düğmeler sağda kalsın diye yer tutulur.
     */
    hideSearch?: boolean
    deleteFunction?: () => void
    updateFunction?: () => void
}

const TableConstantActions = ({
    selectedCount,
    pageName,
    deleteFunction,
    searchTerm,
    setSearchTerm,
    updateFunction,
    onSearchSubmit,
    searchOnly = false,
    hideSearch = false
}: Props) => {
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth)

    const menu = auth.user.user?.data.authorizedMenus.find(x => x.menuName == pageName)

    return (
        <React.Fragment>
            {
                hideSearch && <div style={{ flex: 1 }}></div>
            }

            {
                !hideSearch && (
            <Box flex={1} position='relative'>
                {
                    !Helpers.isEmpty(searchTerm) && (
                        <Box position='absolute' right='15px' top='0' height='100%' justifyContent='center'>
                            <i onClick={() => setSearchTerm('')} className="actionIcon fs-2 fa fa-times color-gray-700" />
                        </Box>
                    )
                }

                <form onSubmit={onSearchSubmit}>
                    <CustomTextInput placeholder='Ara...' height='100%' value={searchTerm} setValue={setSearchTerm} isSolid={false} />
                </form>
            </Box>
                )
            }

            {/* Güncelle düğmesi parametresiz çağrılır: fonksiyon doğrudan bağlanırsa
                tıklama olayı ekranların update(_id) parametresine geçiyor ve adres
                ?id=[object Object] oluyordu. */}
            {/* Güncelle ve Sil seçim yokken de yerinde durur, yalnız pasif olur (05.10.2026). Seçimle
                birlikte belirdiklerinde araç çubuğu ikinci satıra taşıp tabloyu aşağı itiyordu; çift tıklamanın
                ikinci tıklaması üstteki satıra denk gelip o kaydı güncelleme ekranında açıyordu. */}
            {
                (!searchOnly && updateFunction && menu?.canUpdate) && (
                    <button disabled={selectedCount != 1} onClick={() => updateFunction()} className='btn btn-sm btn-flex btn-info'>
                        <i className='fa fa-edit fs-6 color-gray-700 me-1' />
                        Güncelle
                    </button>
                )
            }

            {
                (!searchOnly && deleteFunction && menu?.canDelete) && (
                    <button disabled={selectedCount == 0} onClick={() => dispatch(storeAreYouSureModalCallback(deleteFunction))} className='btn btn-sm btn-flex btn-danger'>
                        <i className='fa fa-trash fs-6 color-gray-700 me-1' />
                        Sil
                    </button>
                )
            }
        </React.Fragment>
    )
}

export default TableConstantActions;
